import gql from "graphql-tag";

export const GET_CPC_QUERY = gql`
  mutation Mutation($input: keywordResearch!) {
    keyPlanner(input: $input) {
      cpcData {
        cpcKeywordDetails {
          avgMonthlySearches
          avgPercentage
          competition
          cpc_high
          cpc_low
          keyword
          locationCountry
        }
        global_searches
        keywordType
      }
      difficulty_score
      keywordPlannerData {
        keywordType
        relatedKeywords {
          avgMonthlySearches
          competition
          keyword
        }
        similarKeywords {
          avgMonthlySearches
          competition
          keyword
        }
      }
      monthlySearchesData {
        month
        monthlySearches
      }
      questionsForKeywords
      searchKeywords
      suggestionKeywords
    }
  }
`;
export const GET_KEYWORD_RESEARCH_DATA = gql`
  query GetAllKeywordResearchData {
    getAllKeywordResearchData {
      _id
      questionsForKeywords
      searchKeywords
      suggestionKeywords
      cpcData {
        cpcKeywordDetails {
          avgMonthlySearches
          avgPercentage
          competition
          cpc_high
          cpc_low
          keyword
          locationCountry
        }
        global_searches
        keywordType
      }
      difficulty_score
      keywordPlannerData {
        keywordType
        relatedKeywords {
          avgMonthlySearches
          competition
          keyword
        }
        similarKeywords {
          avgMonthlySearches
          competition
          keyword
        }
      }
      monthlySearchesData {
        month
        monthlySearches
      }
    }
  }
`;
export const SAVE_KEYWORD_FOR_RANKING = gql`
  mutation Mutation($input: keywordsForRanking!) {
    keywordsForRanking(input: $input) {
      keyword {
        countryCode
        keyword
        loc_id
      }
    }
  }
`;
export const KWD_RESEARCH_PLANNER = gql`
  query GetKeywordResearchPlanner($input: keywordResearch!) {
    getKeywordResearchPlanner(input: $input) {
      relatedKeywords {
        keyword
        avgMonthlySearches
        competition
      }
      similarKeywords {
        keyword
        avgMonthlySearches
        competition
      }
      keywordType
    }
  }
`;

export const MONTHLY_SEARCH_DATA = gql`
  query GetAllMonthlySearchesData($input: keywordResearch!) {
    getAllMonthlySearchesData(input: $input) {
      month
      monthlySearches
    }
  }
`;

export const KWD_CPC_DATA = gql`
  query GetAllKeywordCpcData($input: keywordResearch!) {
    getAllKeywordCpcData(input: $input) {
      cpcKeywordDetails {
        avgMonthlySearches
        avgPercentage
        competition
        cpc_high
        cpc_low
        keyword
        locationCountry
      }
      searchKeywords
      difficulty_score
      global_searches
      keywordType
    }
  }
`;

export const KWD_SUGGESTED = gql`
  query Query($keywordResearch: String!) {
    getSuggestedKeywordsData(keywordResearch: $keywordResearch)
  }
`;

export const KWD_RELEATED = gql`
  query Query($keywordResearch: String!) {
    getKeywordRelatedQuestionsData(keywordResearch: $keywordResearch)
  }
`;
export const KEYWORD_TRENDING = gql`
  query Query($input: keywordResearch!) {
    keywordTrending(input: $input)
  }
`;
